import React from 'react';
import { Button } from '@mui/material';
import { useApproverCreateMutation } from '../../../../services/ticketEasyService/ticketEasy-api';
import { ApproverCommand } from '../../../../services/ticketEasyService/commands/approver/ApproverCommand';
import { useAppSelector } from '../../../../app/hooks';

interface ApproverSubmitButtonProps {
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

export const ApproverSubmitButton: React.FC<ApproverSubmitButtonProps> = ({
    onSuccess,
    onError,
}) => {
    const selectedProfile = useAppSelector(state => state.ticketEasyModule.ApproverProfile);

    const [createApprover, { isLoading }] = useApproverCreateMutation();

    const handleClick = async () => {
        if (!selectedProfile || selectedProfile.locations.length === 0) {
            alert("Incomplete approver details.");
            return;
        }

        const approverCommand = new ApproverCommand({
            id: selectedProfile.id,
            profileId: selectedProfile.profileId || '',
            name: selectedProfile.name || '',
            email: selectedProfile.email || '',
            upn: selectedProfile.upn || '',
            priorityLevel: selectedProfile.priorityLevel,
            isPrimary: selectedProfile.isPrimary,
            approverType: selectedProfile.approverType,
            locations: selectedProfile.locations,
        });

        try {
            await createApprover(approverCommand).unwrap();
            if (onSuccess) onSuccess();
            alert("Approver added successfully!");
        } catch (error: any) {
            if (onError) onError(error.message);
            alert("Failed to add approver: " + error.message);
        }
    };

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            disabled={isLoading}
        >
            {isLoading ? "Submitting..." : "Submit"}
        </Button>
    );
};
